import { SubmitHandler, useForm } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import * as S from './styled';
//Components
import ActionButton from '../../../Button/ActionButton';
import LayoutWithList from '../../../LayoutModal/WithList';
import Loading from "../../../Loading";
//hooks
import { useEffect } from 'react';
import { apiUpdate } from '../../../../hooks/apiUpdate';
import useLoading from '../../../../hooks/useLoading';
//Interfaces
import { Inputs } from 'Interfaces/IAgreement';

interface ICreate {
    isOpenModalMaterial: boolean;
    selectedUrlId: number | null;
    setModalClose: () => void;
    updateList: () => void;
}

export default function Update({ isOpenModalMaterial, setModalClose, selectedUrlId, updateList }: ICreate) {

    const {
        register,
        handleSubmit: handleFormSubmit,
        setValue,
        formState: { errors },
    } = useForm<Inputs>();

    const { handleSubmit } = apiUpdate(`agreement/${selectedUrlId}`);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {

            const response = await axiosInstance.get(`agreement/${selectedUrlId}`);
            const addressData = response.data;
            for (const key in addressData) {
                setValue(key as keyof Inputs, addressData[key]);
            }

        } catch (error) {
            console.log("Error: ", error);
        } finally {
            stopLoading();
        }
    };

    useEffect(() => {
        if (isOpenModalMaterial && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModalMaterial, selectedUrlId]);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            const response = await handleSubmit(data);
            if (response === 200) {
                alert("Convênio atualizado com sucesso!");
                updateList();
                setModalClose();
            }
        } catch (error: any) {
            alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
        }
    };

    if (isOpenModalMaterial) {
        return (
            <LayoutWithList
                title='Editar Convênio'
                subTitle='Atualize as informações do convênio em sua base de dados.'
                setModalClose={setModalClose}
            >
                <S.Container>
                    {
                        isLoading ? (
                            <Loading />
                        ) :
                            <S.SeparateDiv>
                                <S.FormInput>
                                    <S.Label>
                                        Nome do convênio
                                        <span>*</span>
                                    </S.Label>
                                    <S.Input placeholder='Informe o nome do convênio' type='text' {...register("agreement", { required: true })} />
                                    {errors.agreement && <S.InforErro>Campo Obrigatório</S.InforErro>}
                                </S.FormInput>

                                <S.ContentButton>
                                    <ActionButton name='Atualizar' onClick={handleFormSubmit(onSubmit)} />
                                </S.ContentButton>
                            </S.SeparateDiv>
                    }
                </S.Container>
            </LayoutWithList>
        )
    } return null
}